module.exports = __webpack_public_path__ + "img/list.0f9b9224.png";